<template>
  <div class="body-list-box">
    <div v-if="email_arr.length==0 && !is_loading">
      <div class="mail-list-item-empty" v-for="key in 4" :key="key"></div>
    </div>
    <div v-if="is_loading">
      <div class="mail-list-item-empty-animated" v-for="key in 4" :key="key"></div>
    </div>
    <div v-if="email_arr.length>0 && !is_loading">
      <div
        class="mail-list-item"
        v-for="email in email_arr"
        :key="email.id"
        :class="[isActiveEmail(email.id) ? 'active' : '', !email.isRead ? 'unread' : 'read']"
        @click="setActiveEmail(email.id)"
      >
        <div class="mail-list-attachment" v-if="email.hasAttachments">
          <img class="attach" src="@/assets/img/email/privitak.svg" />
        </div>
        <div class="mail-item-info">
          <div class="mail-item-info-name">
            {{ retrieveEmailSenderName(email) }}
          </div>
          <div class="mail-item-info-mail">
            {{ retrieveEmailSenderEmail(email) }}
          </div>
        </div>
        <div class="mail-item-title">{{ retrieveEmailSubject(email) }}</div>
      </div>
      <div
        class="load-more-mails"
        v-if="can_load_more"
        @click="loadMoreMails()"
      >
        {{ $t('components.email.load_more') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected_email: {
      type: Object,
      default: null,
    },
    email_arr: {
      type: Array,
      default: [],
    },
    can_load_more: {
      type: Boolean,
      default: true,
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setActiveEmail(email_id) {
      this.$emit("setActiveEmail", email_id);
    },
    loadMoreMails() {
      this.$emit("loadMore");
    },

    retrieveEmailSenderEmail(email) {
      if (!email.sender || !email.sender.emailAddress) {
        return this.$t('components.email.undefined');
      }
      const address = email.sender.emailAddress.address;
      return address.length > 30 ? address.slice(0, 30) + '...' : address;
    },

    retrieveEmailSenderName(email) {
      return email.sender
        ? email.sender.emailAddress.name.length > 25
          ? email.sender.emailAddress.name.slice(0, 25) + "..."
          : email.sender.emailAddress.name
        : this.$t('components.email.undefined');
    },

    retrieveEmailSubject(email) {
      return email.subject;
    },

    /**
     * Method checks if the email is the one selected for further inspection.
     * That way if boolean value is true, ACTIVE class is then applied.
     * @param {*} id id of email
     */
    isActiveEmail(id) {
      if (this.selected_email) {
        return this.selected_email.email.id == id;
      } else {
        return false;
      }
    },
  },
};
</script>

<style></style>
